import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Row, Col } from "react-bootstrap";

import CardNew from "components/molecules/Card/CardNew";

const QuickService = function ({ data, loadingData, isDrawer }) {
  const { special_requirements, incoterm, incoterm_instructions } = data?.organization || {};

  return (
    <CardNew
      className={`${isDrawer ? "" : "mb-15"} font-b3`}
      isLoading={loadingData}
      title={<FormattedMessage id="new-request.service.service" defaultMessage="Service" />}
    >
      {incoterm && (
        <Row className="mb-2">
          <Col className="text-secondary">
            <FormattedMessage id="quote-request-detail.incoterms" defaultMessage="Incoterms" />
          </Col>
          <Col>{incoterm === "NONE" ? "None" : incoterm || "-"}</Col>
        </Row>
      )}
      {incoterm_instructions && (
        <Row className="mb-2">
          <Col className="text-secondary">
            <FormattedMessage id="new-request.service.incotermInstructions" defaultMessage="Incoterm instructions" />
          </Col>
          <Col>{incoterm_instructions || "-"}</Col>
        </Row>
      )}
      {special_requirements &&
        special_requirements.map(({ label, value, additional_information }) => (
          <Row className="mb-2" key={`${label}_${value}`}>
            <Col className="text-secondary">{label}</Col>
            <Col className="font-weight-bold">
              {value ? `Yes${additional_information ? `, ${additional_information}` : ""}` : "No"}
            </Col>
          </Row>
        ))}
      {special_requirements && special_requirements.length === 0 && (
        <div className="text-center text-secondary my-2">No service data</div>
      )}
    </CardNew>
  );
};

QuickService.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  loadingData: PropTypes.bool.isRequired,
  isDrawer: PropTypes.bool,
};

QuickService.defaultProps = {
  isDrawer: false,
};

export default QuickService;
